module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "form-control",
    class: {
      'error': _vm.error, 'success': _vm.success
    },
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "min": _vm.min,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.$emit('enter')
      },
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423eedad","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/regularInput.vue
// module id = 835
// module chunks = 1